module.exports = __webpack_public_path__ + "static/media/5-pool-07_26_2020.1146a9b5.jpg";